import React from "react";
import Marquee from "react-fast-marquee";
import { useApp } from "../../context/AppContext";

export function MarqueeBand() {
  const { c } = useApp();
  return (
    <section data-testid="marquee-section" className="border-y border-[#002355]/10 bg-[#f5f7fa] py-8 md:py-10">
      <Marquee speed={44} gradient={false} autoFill>
        {c.marquee.map((word, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-display text-4xl font-extrabold uppercase tracking-tight text-[#002355] md:text-6xl">
              {word}
            </span>
            <span className="text-3xl text-[#e8a93d] md:text-5xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
